import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencilLine: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pencil-line, signature, write"><path d="M2.75 21.25V17L17 2.75L21.25 7L7 21.25H2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M12.75 21.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPencilLine;
